import { FC, useCallback } from 'react';
import { useClientTranslation } from '@lib/i18n/client';
import { Pictogram, PictogramName } from '@tuic/web-compositions/core/Pictogram';
import { Button } from '@tuic/web-compositions/core/Button';
import { DialogBody } from '@modules/get-slash-internet-card/components/dialog-views/dialog-body';
import { RefreshDialogHandler } from '@modules/get-slash-internet-card/components/dialog-view-renderer';
type Props = {
  pictogram?: PictogramName;
  headline?: string;
  text?: string;
  furtherButtonLabel?: string;
  refreshDialog: RefreshDialogHandler;
};
export const BookingSuccess: FC<Props> = props => {
  const {
    pictogram,
    headline,
    text,
    furtherButtonLabel,
    refreshDialog
  } = props;
  const {
    t
  } = useClientTranslation();
  const handleClick = useCallback(() => {
    refreshDialog({
      indicator: true
    });
  }, [refreshDialog]);
  return <DialogBody colored data-sentry-element="DialogBody" data-sentry-component="BookingSuccess" data-sentry-source-file="booking-success.tsx">
      <div className="text-center text-marine-high-emphasis">
        <div className="space-y-6">
          <div className="space-y-4">
            <Pictogram name={pictogram ?? 'checkmark'} size="md" data-sentry-element="Pictogram" data-sentry-source-file="booking-success.tsx" />
            <h3 className="headline-lg">
              {headline ?? t('Buchung bestätigt')}
            </h3>
          </div>
          <p>
            {text ?? t('Ihr Internettarif ist gebucht – Sie können ihn sofort aktivieren!')}
          </p>
        </div>

        <Button onClick={handleClick} className="mt-4" data-sentry-element="Button" data-sentry-source-file="booking-success.tsx">
          {furtherButtonLabel ?? t('Tarif jetzt starten')}
        </Button>
      </div>
    </DialogBody>;
};